import { finalize, switchMap } from 'rxjs/operators';
import { Component, AfterContentInit, OnInit, OnDestroy, ElementRef } from '@angular/core';
import { DivisionDTO, getSimpleIdentifierFromString } from '../../api/plyca-dtos';
import { DossierService } from '../../dossiers/dossier.service';
import { HelpService, HelpType } from '../common/help/help.service';
import { generateRandomIdentifier } from '../../ui.service';
import { HeaderActionsService } from '../common/sub-header/header-actions.service';
import { TreeNode } from 'primeng-lts/api';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng-lts/dynamicdialog';
import { BaseComponent } from '../common/baseComponent/base.component';
import { WaitLoadingService } from '../common/waitLoading/wait-loading.service';
import { Subject } from 'rxjs';

@Component({
  selector: 'divisionTreeComponent',
  templateUrl: 'divisionTree.template.html'
})
export class DivisionTreeComponent extends BaseComponent implements AfterContentInit, OnInit, OnDestroy {
  loading = false;

  // objeto seleccionado
  dossierId: string;
  activeDocumentClassIdList: string[];
  visibleDocumentClassIdList: string[];
  noVisibleDocumentClassIdList: string[];
  divisiones: DivisionDTO[];
  rootDivision: TreeNode[];
  filteredDivisions: TreeNode[];
  selectedObject: DivisionDTO;
  tagsParent: string[];
  windowHash: string;

  private expansion: string;

  filterText = '';
  private modelChanged: Subject<string> = new Subject<string>();
  MIN_SEARCH_TEXT_LENGHT = 3;


  constructor(
    private elem: ElementRef,
    private dossierService: DossierService,
    public ref: DynamicDialogRef,
    public helpService: HelpService,
    private headerActionsService: HeaderActionsService,
    public dialogConfig: DynamicDialogConfig,
    private waitService: WaitLoadingService
  ) {
    super();
    this.dossierId = dialogConfig['dossierId'];
    let actives = dialogConfig['activeDivisions'];
    let visibles = dialogConfig['visibleDivisions'];
    let filterDivisionType = dialogConfig['filterDivisionType'];
    this.expansion = dialogConfig['expansion'];
    if (actives != undefined) {
      this.activeDocumentClassIdList = actives.split(',');
    }
    if (visibles != undefined) {
      this.visibleDocumentClassIdList = visibles.split(',');
    }
    if (filterDivisionType != undefined) {
      this.noVisibleDocumentClassIdList = filterDivisionType.split(',');
    }




    this.subscribe(this.helpService.getStoreTagsObservable().pipe(
      switchMap((helpTags) => {
        this.tagsParent = helpTags
        return this.helpService.showContextHelpObservable(HelpType.SEL_DIV)
      })));

  }

  ngOnInit(): void {
    this.waitService.startWaiting();
    this.loadData();

    this.windowHash = generateRandomIdentifier();
    //   header: 'Ejecución de la acción ' + action.name + '('+ action.identifier + ')', //
    this.headerActionsService.clearWindowActions(this.windowHash);

    this.subscribe(this.headerActionsService
      .addWindowAction(
        'General.back',
        'fas fa-chevron-left',
        'btn-outline-secondary',
        true, this.windowHash
      ),
      () => {
        this.cancel();
      });



  }

  ngOnDestroy(): void {
    this.modelChanged.unsubscribe();
    this.subscribe(this.helpService.showContextHelpObservable(this.tagsParent).pipe(
      finalize(() => {
        this.headerActionsService.clearWindowActions(this.windowHash);
        super.ngOnDestroy();
      })));
  }


  ngAfterContentInit(): void { }

  loadData() {
    this.loading = true;
    this.subscribe(
      this.dossierService.getDivisionsTree(this.dossierId, this.expansion)
        .pipe(
          finalize(() => this.waitService.cancelWaiting())),
      rootNode => {
        this.rootDivision = [];
        this.rootDivision.push(this.division2Node(rootNode, true));
        this.loading = false;

        // Se hace una copia para tener siempre el original sin filtrar
        this.filteredDivisions = JSON.parse(JSON.stringify(this.rootDivision));


        this.filterText = ''; // Se inicializa la pantalla sin filtro
        // filtramos
        // this.filterInternal(this.filteredDivisions);
        // eliminamos filtrados
        // this.filteredDivisions = this.removeNoVisible(this.filteredDivisions);
      });
  }

  truncateDivisionDescription(name: string) {
    if (!name) {
      return '';
    }
    if (name.length > 200) {
      return name.substring(0, 200) + ' ...';
    } else {
      return name;
    }
  }

  division2Node(division: DivisionDTO, isRoot = false): TreeNode {
    let icon = 'fa-2x  fa-folder-o ';
    // hack para la descripcion en el tree
    // division['description'] = division.name;


    let divisionName = division.name;
    let divId = getSimpleIdentifierFromString(division.identifier);
    if (divId === '0') {
      if (division.project.title) {
        divisionName = division.project.title;
      } else if (division.project.abbreviatedTitle) {
        divisionName = division.project.abbreviatedTitle;
      }
    }
    divisionName = this.truncateDivisionDescription(divisionName);
    if (divId === '0' && division.project.contractFolderId !== undefined) {
      divisionName = division.project.contractFolderId + ' ' + divisionName;
    }

    let divisionNode: TreeNode = {
      data: division,
      expanded: true,
      label: divisionName,
      selectable: this.isActive(division.documentClass.identifier)

      // children: this.children2Nodes(division)
    };
    divisionNode['children'] = this.children2Nodes(division);

    return divisionNode;

    //    division['icono'] = icon;

  }

  children2Nodes(divisionNode: DivisionDTO) {
    let _children = [];
    if (this.isVisible(divisionNode.documentClass.identifier)) {
      if (divisionNode.children) {
        divisionNode.children.forEach(child => {
          if (this.isVisible(child.documentClass.identifier)) {
            let tmp = this.division2Node(child);
            _children.push(tmp);
          }
        });
      }
    }
    return _children;
  }




  isLoading(): boolean {
    return this.loading;
  }

  cancel(): void {
    this.ref.close();
  }

  accept(selection: any): void {
    if (selection && selection.node) {
      console.log('division', selection);
      this.ref.close(selection.node.data);
    }
  }

  isActive(activeId: string) {
    if (this.activeDocumentClassIdList == undefined || this.activeDocumentClassIdList.length == 0) {
      return true;
    }

    let objs = this.activeDocumentClassIdList.find(typeId => typeId == activeId);
    return objs !== undefined && objs.length > 0;
  }

  isVisible(visibleId: string) {
    if (this.noVisibleDocumentClassIdList !== undefined && this.noVisibleDocumentClassIdList.length > 0) {
      let objs = this.noVisibleDocumentClassIdList.find(typeId => typeId == visibleId);
      return objs == undefined || (objs !== undefined && objs.length <= 0);
    } else {
      if (this.visibleDocumentClassIdList == undefined || this.visibleDocumentClassIdList.length == 0) {
        return true;
      }
      let objs = this.visibleDocumentClassIdList.find(typeId => typeId == visibleId);
      return objs !== undefined && objs.length > 0;
    }
  }

  getIconClass(documentClassId: string): string {
    let cssClass = '';
    switch (documentClassId) {
      case '00000': {
        cssClass = 'fa fa-archive ';
        break;
      }
      case '00600': {
        cssClass = 'fa  fa-file-contract ';
        break;
      }
      default: {
        cssClass = 'far  fa-folder-open ';
        break;
      }
    }

    return cssClass;

  }




  updateFilter() {

    if (this.filterText === undefined || this.filterText === '') {
      this.loading = true;

      // Se hace una copia para tener siempre el original sin filtrar
      this.filteredDivisions = JSON.parse(JSON.stringify(this.rootDivision));
      this.loading = false;
    } else if (
      this.filterText &&
      this.filterText.length >= this.MIN_SEARCH_TEXT_LENGHT
    ) {

      // Se hace una copia para tener siempre el original sin filtrar
      this.filteredDivisions = JSON.parse(JSON.stringify(this.rootDivision));
      this.loading = true;
      // inicializar visibilidad (false)
      this.initializeVisible(this.filteredDivisions);
      // filtramos
      this.filterInternal(this.filteredDivisions);
      // eliminamos filtrados
      this.filteredDivisions = this.removeNoVisible(this.filteredDivisions); this.loading = false;
    }



  }



  initializeVisible(nodes: TreeNode[]) {
    nodes.forEach((node: TreeNode) => {
      node['visible'] = false;
      if (node.children) {
        this.initializeVisible(node.children);
      }
    });
  }

  changed(text: string) {
    this.modelChanged.next(text);
  }



  removeNoVisible(nodes: TreeNode[]): TreeNode[] {
    let ret: TreeNode[] = nodes.filter((node: TreeNode) =>
      this.isNodeVisible(node)
    );
    ret
      .filter((node: TreeNode) => node.children)
      .map((node: TreeNode) => {
        if (node.children) {
          node.children = this.removeNoVisible(node.children);
        }
      });
    return ret;
  }

  isNodeVisible(node: TreeNode): boolean {
    let visible = node['visible'];
    if (!visible && node.children) {
      visible = this.isNodeVisibleRecursiva(node.children);
    }
    return visible;
  }

  isNodeVisibleRecursiva(nodes: TreeNode[]) {
    let ret = false;
    if (nodes.find(node => node['visible'])) {
      ret = true;
    } else {
      nodes.forEach((node: TreeNode) => {
        if (node.children) {
          let tmp = this.isNodeVisibleRecursiva(node.children);
          ret = ret || tmp;
        }
      });
    }
    return ret;
  }


  filterInternal(nodes: TreeNode[]) {
    nodes.forEach((node: TreeNode) => {
      let visible = this.compareNode(this.filterText, node);
      // node['visible'] = visible; -> Si se hace la inicializacion esto no es necesario
      if (visible) {
        node.label = this.formatLabel(node.label);
        // if (node.label.indexOf('i>') > 0) {
        //   console.log('label formateada', node.label);
        // }
        this.markNodeTreeAsVisible(node);
      }
      if (node.children) {
        this.filterInternal(node.children);
      }
    });
  }


  formatLabel(nodeLabel: string): string {
    let words = this.filterText
      .trim()
      .split(/\s+/);

    let text = nodeLabel;
    words.forEach((word: string) => {
      text = this.markText(text, word);
    });
    return text;
  }



  removeMarkedText(text) {
    // Crear expresiones regulares para encontrar y eliminar las etiquetas <span class="markedtext"> y </span>
    let openTagRegex = /<span class="markedtext">/gi;
    let closeTagRegex = /<\/span>/gi;

    // Reemplazar todas las ocurrencias de las etiquetas con una cadena vacía
    text = text.replace(openTagRegex, '');
    text = text.replace(closeTagRegex, '');

    return text;
  }
  normalize(text) {

    return this.removeMarkedText(text).normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }

  normalizeAccents(text) {
    return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
  }


  markText(text, word) {
    let result = text + '';
    if (word !== '/') {

      let markedParts = [];
      let normalizedText = this.normalizeAccents(text);
      let normalizedWord = this.normalizeAccents(word);

      // Crear una expresión regular para buscar la palabra sin diferenciar mayúsculas, minúsculas y acentos
      let regex = new RegExp(normalizedWord, 'gi');

      // Encontrar todas las coincidencias de la palabra en el texto
      let match;
      while ((match = regex.exec(normalizedText)) !== null) {
        let isInMarkedPart = markedParts.some(function (part) {
          return match.index >= part.start && match.index < part.end;
        });
        if (!isInMarkedPart) {
          let markedPart = {
            start: match.index,
            end: regex.lastIndex
          };
          markedParts.push(markedPart);
        }
      }

      // Construir el texto con las partes marcadas y no marcadas
      result = '';
      let lastIndex = 0;
      markedParts.forEach(function (part) {
        result += text.slice(lastIndex, part.start);
        result += '<span class="markedtext">' + text.slice(part.start, part.end) + '</span>';
        lastIndex = part.end;
      });
      result += text.slice(lastIndex);

    }

    return result;
  }

  compareNode(searchText: string, node: TreeNode): boolean {

    let words = searchText.trim().split(/\s+/);
    // let words = this.normalizeText(searchText).split(' ');
    let text = node.label;
    let matches = [];

    words.forEach((word: string) => {
      if (word !== ' ') {
        let wordMatches = this.findMatchesIgnoringAccents(text, word);
        if (wordMatches && wordMatches.length > 0) {
          matches.push(...wordMatches);
        }

      }
    });
    return matches && matches.length > 0;
  }


  findMatchesIgnoringAccents(text, word) {
    // Normalizar el texto y la palabra para eliminar los acentos
    let normalizedText = this.normalize(text);
    let normalizedWord = this.normalize(word);

    // Crear una expresión regular para buscar la palabra sin diferenciar mayúsculas, minúsculas y acentos
    let regex = new RegExp(normalizedWord, 'gi');

    // Usar la función match para encontrar todas las coincidencias en el texto normalizado
    let matches = normalizedText.match(regex);

    // Si no hay coincidencias, devolver un array vacío
    return matches || [];
  }

  markNodeTreeAsVisible(node: TreeNode) {
    node['visible'] = true;
    if (node.parent) {
      this.markNodeTreeAsVisible(node.parent);
    }

  }

  markNodeTreeAsVisibleRecursive(
    node: TreeNode,
    parentNode: TreeNode,
    level: number
  ) {
    if (parentNode) {
      parentNode['visible'] = true;
      if (parentNode.label !== node.label && parentNode.children) {
        level++;
        let parent2 = parentNode.children.find((tmp: TreeNode) => {
          return tmp.label.startsWith(
            node.label.substring(0, level + 2)
          );
        });
        if (parent2) {
          this.markNodeTreeAsVisibleRecursive(node, parent2, level++);
        }
      }
    }
  }
}
